<template>
  <div class="unknown" data-testid="unknown">
    Component {{ resource.resource_class_name }} not registered.
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: [Object, null],
      default: null
    }
  },
}
</script>

<style lang="scss">
  .unknown {
    padding: 1rem;
    border: 2px dashed red;
    background-color: rgba(255,0,0,0.2);
    text-align: center;
    font-weight: bold;
    max-width: 100%;
    word-wrap: break-word;
  }
</style>
